import { Box, Divider, Typography } from "@mui/material";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { useSurgeryColumns } from "../model/surgeryColumns";
import { mockSurgeryRows } from "../model/surgeryRows";
import { ToolType } from "../canvaComponent/canvas/type/types";
import { useTranslate } from "src/locales";
import KovaCanvas, { Shape } from "../canvaComponent/canvas/KovaCanvas";
import { FillPattern, LineStyle } from "../canvaComponent/canvas/DrawingToolbar";

interface SurgerySectionProps {
    shapes: Shape[];
    setShapes: React.Dispatch<React.SetStateAction<Shape[]>>;
    tool: ToolType;
    strokeColor: string;
    fillColor: string;
    lineStyle: LineStyle;
    lineWidth: number;
    fillPattern: FillPattern;
}

const SurgerySection = ({
    shapes,
    setShapes,
    tool,
    strokeColor,
    fillColor,
    lineStyle,
    lineWidth,
    fillPattern,
}: SurgerySectionProps) => {
    const { t } = useTranslate();
  const surgeryColumns = useSurgeryColumns();

    return (
    <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2 }}>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: { xs: 'auto', md: '80vh' }, // responsive: auto on mobile, limited on desktop
                maxHeight: '100%',
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#63B4FF33",
                    borderRadius: "8px",
                    p: 1,
                    mb: 2,
                }}
            >
                <Typography fontWeight={600} color="#2979C3">
                    {t('safety-surgery.surgeries')}
                </Typography>
            </Box>

            <Box sx={{ flexShrink: 0, height: 200, overflow: "auto" }}>
                <ByzMuiDataGrid
                    rows={mockSurgeryRows}
                    columns={surgeryColumns}
                    pageSize={5}
                    autoHeight={false}
                    sx={{ height: "100%" }}
                />
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ flex: 1, minHeight: 300, overflow: "hidden" }}>
                <KovaCanvas
                    shapes={shapes}
                    setShapes={setShapes}
                    tool={tool}
                    strokeColor={strokeColor}
                    fillColor={fillColor}
                    lineStyle={lineStyle}
                    lineWidth={lineWidth}
                    fillPattern={fillPattern}
                    backgroundImageUrl="/images/body-diagram.png"
                    //selectedShapeId={typeof selectedShapeId !== 'undefined' ? selectedShapeId : null}
                />
            </Box>
        </Box>
    </Box>
    );
};

export default SurgerySection;

//çizimleirn listesini tutan component

//  {/* Çizimlerin listesi */}
            
//              <Box sx={{ mt: 2 }}>
//                 {shapes.length > 0 && (
//                     <Box sx={{
//                         border: '1px solid #e0e0e0',
//                         borderRadius: 2,
//                         p: 2,
//                         bgcolor: '#fafbfc',
//                         maxHeight: 200,
//                         overflowY: 'auto',
//                     }}>
//                         {shapes.map((shape, idx) => (
//                             <Box key={shape.id} sx={{
//                                 mb: 1,
//                                 p: 1.5,
//                                 border: '1px solid #b3c0d1',
//                                 borderRadius: 1,
//                                 bgcolor: '#fff',
//                                 boxShadow: 1,
//                             }}>
//                                 <Typography variant="subtitle2" fontWeight={600} gutterBottom>
//                                     {shape.type.charAt(0).toUpperCase() + shape.type.slice(1)}
//                                 </Typography>
//                                 {/* İsterseniz burada daha fazla bilgi veya küçük bir önizleme ekleyebilirsiniz */}
//                             </Box>
//                         ))}
//                     </Box>
//                 )}
//             </Box> 